import { ReactNode } from 'react'
import { Helmet } from 'react-helmet'

import PlainButtonLink from 'app/common/ui-next/plain-button-as-link'

import Header from './header'
import styles from './page-template.module.scss'

type Props = {
  title?: string
  header?: string
  linkBack?: () => void
  titleLinkBack?: string
  children: ReactNode
}

const PageTemplate = ({ title, header, children, linkBack, titleLinkBack }: Props) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={styles.row}>
        {header && <Header>{header}</Header>}
        {titleLinkBack && <PlainButtonLink onClick={linkBack}>{titleLinkBack}</PlainButtonLink>}
      </div>
      {children}
    </>
  )
}

export default PageTemplate
